import { Box, Divider, TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useTestCartData from '../hooks/useTestCartData';

const PatientInfo = () => {
    const userState = useSelector(state => state.auth.user);
    const {patientAge, patientName, patientNumber, updateCartOrderData} = useTestCartData();

    const handleOrderState = (e) => {
        const {name, value} = e.target;
        updateCartOrderData({[name]: value});
    };

    useEffect(() => {
        if (!userState) {
            return;
        }
        const patientName = userState.middleName ? `${userState.firstName} ${userState.middleName} ${userState.lastName}` : `${userState.firstName} ${userState.lastName}`;
        updateCartOrderData({
            patientAge: userState.age,
            patientName,
            patientNumber: userState.mobileNumber,
        });
    }, [userState, updateCartOrderData]);
    return (
        <div className="patient-info-content place-order-info-box">
            <Typography variant="h6">Patient Info</Typography>
            <Divider />
            <Box>
                <TextField fullWidth label="Patient Name" placeholder='Name' variant="outlined" value={patientName} onChange={handleOrderState} name='patientName' />
            </Box>
            <Box>
                <TextField fullWidth label="Phone Number" placeholder='Phone Number' variant="outlined" value={patientNumber} onChange={handleOrderState} name='patientNumber' />
            </Box>
            <Box>
                <TextField fullWidth label="Age (in years)" placeholder='Age' variant="outlined" value={patientAge} onChange={handleOrderState} name='patientAge' />
            </Box>
        </div>
    );
};

export default PatientInfo;